<template>
  <div class='week atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="form" class="atb-input">
          <el-form-item label="时间">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.date"></el-date-picker>
          </el-form-item>
          <el-form-item label="新增类型">
            <el-select v-model="form.type" placeholder="新增类型">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="form.type" placeholder="状态">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input v-model="form.type" placeholder="新增类型"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="week"
          :merge-cells="mergeCells"
          :row-class-name="setRowClass"
          @checkbox-all="selectAllEvent"
          :edit-config="{trigger: 'click', mode: 'cell'}"
        >
          <vxe-table-column type='checkbox' width='40' align='center'>
            <template #checkbox="scope">
              <template v-if="scope.rowIndex === 0">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>KPI工作</span>
                  <span @click='addKpi'>新增</span>
                </div>
              </template>
              <template v-else-if="scope.rowIndex === kpiLength + 1">
               <div class='kpi-add atb-flex atb-flex-justify-between atb-flex-items-center'>
                  <span>例行工作</span>
                  <span>新增</span>
                </div>
              </template>
              <template v-else>
                <span title="选择/取消" :class="['vxe-cell--checkbox', scope.checked ? 'is--checked' : '']"  @click.stop="selectSingle(scope.row)">
                  <span class="vxe-checkbox--icon vxe-checkbox--checked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--unchecked-icon"></span>
                  <span class="vxe-checkbox--icon vxe-checkbox--indeterminate-icon"></span>
                </span>
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column field="sex" title="分类"></vxe-table-column>
          <vxe-table-column field="index" title="NO." width='50' align='center'></vxe-table-column>
          <vxe-table-column field="sex" title="类别" :edit-render="{name: 'ElSelect', autofocus: '.el-input__inner'}">
            <template #edit="scope">
              <el-select v-model="scope.row.sex" @change="$refs.kpi.updateStatus(scope)">
                <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </template>
          </vxe-table-column>
          <vxe-table-column field="program" title="工作项目">
<!--            <template #edit="{ row }">-->
<!--              <el-autocomplete v-model="row.program" :fetch-suggestions="querySearch"></el-autocomplete>-->
<!--            </template>-->
            <template #default="{ row }">
              <el-popover
                placement="right-start"
                width="416"
                :visible-arrow='false'
                trigger="click">
                  <el-checkbox-group v-model="checkList" class='program-check'>
                    <li class='atb-flex' v-for='item in programData' :key='item.id'>
                      <el-checkbox :label="item.id">
                        <span>{{item.name}}</span>
                      </el-checkbox>
                      <div>
                        <p class='desc'>{{item.address}}</p>
                        <p class='date'>{{item.date}}</p>
                      </div>
                    </li>
                  </el-checkbox-group>
                  <div class='footer'>
                    <el-checkbox class='select-all-program' v-model='selectAllProgram'>全选</el-checkbox>
                    <el-button class="atb-dialog-confirm" type="primary" @click="showNoticeDetail = false">确认</el-button>
                    <el-button class="atb-dialog-cancel" type="cancel" @click="showNoticeDetail = false">取消</el-button>
                  </div>
                <span class='program-tip' slot="reference">{{row.program}}<i class='icon-synchronize'></i></span>
              </el-popover>
            </template>
          </vxe-table-column>
          <vxe-table-column field="name" title="责任人" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-input type='textarea' autosize placeholder="请输入内容" v-model="row.name"></el-input>
            </template>
          </vxe-table-column>
          <vxe-table-column field="age" title="总目标"></vxe-table-column>
          <vxe-table-column field="date" title="总目标完成时间" :edit-render="{autofocus: '.el-textarea__inner'}">
            <template #edit="{ row }">
              <el-date-picker v-model="row.date" type="date" format="yyyy/MM/dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{ formatDate(row.date, 'yyyy/MM/dd') }}</template>
          </vxe-table-column>
          <vxe-table-column field="age" title="一周需达到的目标"></vxe-table-column>
          <vxe-table-column field="age" title="一周目标完成时间"></vxe-table-column>
          <vxe-table-column field="age" title="权重" width='50'></vxe-table-column>
          <vxe-table-column field="age" title="重点关注"></vxe-table-column>
          <vxe-table-column field="age" title="完成情况"></vxe-table-column>
          <vxe-table-column field="age" title="愿意"></vxe-table-column>
          <vxe-table-column field="age" title="备注"></vxe-table-column>
          <vxe-table-column field="age" title="新增人"></vxe-table-column>
          <vxe-table-column field="age" title="提交状态"></vxe-table-column>
          <vxe-table-column field="status" title="操作" fixed width='180' class-name='operation'>
            <template #default="scope">
              <el-tooltip class='item' effect='dark' content='提交' placement="bottom">
                <i class='icon-send'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='复制' placement="bottom">
                <i class='icon-copy'></i>
              </el-tooltip>
              <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                <i class='icon-close delete' @click='deleteData(scope.rowIndex)'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="showHandle = false">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'

  export default {
    name: "index",
    data() {
      return {
        activeName: 'second',
        currentTab: 0,
        showHandle: false,
        handleDelete: true,
        tabList: [
          {
            label: '待处理',
            id: 0,
          },
          {
            label: '已处理',
            id: 1,
          },
        ],
        form: {
          date: '',
          type: ''
        },
        columnLength: 0, // 表头长度 动态计算合并

        mergeCells: [],
        result: {},
        kpi: [],
        business: [],
        categoryList: [
          {value: '前端', name: '前端'},
          {value: '后端', name: '后端'}
        ],
        programList: [
          {"value": "三全鲜食（北新泾店）", "address": "长宁区新渔路144号"},
          {"value": "Hot honey 首尔炸鸡（仙霞路）", "address": "上海市长宁区淞虹路661号"},
          {"value": "新旺角茶餐厅", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113"},
        ],
        unHandleList: [],
        handledList: [],
        allChecked: false,
        programData: [
          {id: 10001, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10002, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10003, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10004, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'},
          {id: 10005, name: '戴永明', address: 'A2000plus项目界面设计完成,前端样式验收保质保量', date: '2021/04/19-2021/04/20'}
        ],
        checkList: [],
        selectAllProgram: false,
        isChecked: false
      }
    },
    computed: {
      kpiLength() { //kpi数据长度 动态增加数据使用
        return this.kpi.length;
      },
      tableData() {
        return [{}, ...this.kpi, {}, ...this.business];
      }
    },
    created() {
      setTimeout(() => {
        this.result = {
          kpi: [
            {
              id: 10001,
              name: 'Test1',
              role: 'Develop',
              sex: 'Man',
              program: 'A2000',
              age: 28,
              date: '',
              address: 'vxe-table 从入门到放弃',
              status: 1
            },
            {id: 10002, name: 'Test2', program: 'A2000', role: 'Test', sex: 'Women', date: '', age: 22, address: 'Guangzhou', status: 2},
            {id: 10003, name: 'Test3', program: 'A2000', role: 'PM', sex: 'Man', age: 32, date: '', address: 'Shanghai', status: 3},
            {id: 10004, name: 'Test4', program: 'A2000', role: 'Designer', sex: 'Women', date: '', age: 23, address: 'vxe-table 从入门到放弃', status: 4},
            {id: 10005, name: 'Test5', program: 'A2000', role: 'Develop', sex: 'Women', date: '', age: 30, address: 'Shanghai', status: 5},
          ],
          business: [
            {
              id: 10001,
              name: 'Test1',
              role: 'Develop',
              sex: 'Man',
              program: 'A2000',
              age: 28,
              date: '',
              address: 'vxe-table 从入门到放弃',
              status: 1
            },
            {id: 10002, name: 'Test2', program: 'A2000', role: 'Test', sex: 'Women',},
            {id: 10003, name: 'Test3', program: 'A2000', role: 'PM', sex: 'Man',},
            {id: 10004, name: 'Test4', program: 'A2000', role: 'Designer', sex: 'Women'},
            {id: 10005, name: 'Test5', program: 'A2000', role: 'Develop', sex: 'Women',},
          ],
        };
        this.kpi = this.result.kpi.map((item, index) => {
          return {...item, index: index + 1};
        });
        this.business = this.result.business.map((item, index) => {
          return {...item, index: index + 1};
        });
      }, 50);

    },
    mounted() {

    },
    methods: {
      selectAllEvent({ records }) {
        console.log(records);
      },
      selectSingle(row){
        this.$refs.week.toggleCheckboxRow(row);
        console.log(this.$refs.week.getCheckboxRecords());
      },
      addKpi() {
        this.kpi.push({
          id: '',
          name: '',
          role: '',
          sex: '',
          program: '',
          age: '',
          date: '',
          address: '',
          status: ''
        });
      },
      setRowClass({rowIndex}) {
        if (rowIndex == 0 || rowIndex == this.kpiLength + 1) {
          return 'main-row';
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format)
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      getCurrent(item) {
        this.currentTab = item.data.id;
      },
      querySearch(queryString, cb) {
        let programList = this.programList;
        // 调用 callback 返回建议列表的数据
        cb(programList);
      },
      deleteData(index) {
        if (index <= this.kpi.length) {
          this.kpi.splice(index - 1, 1);
        }
      }
    },
    watch: {
      kpiLength:{
        handler(newVal){
          this.mergeCells = [
            {row: 0, col: 0, rowspan: 1, colspan: 18},
            {row: newVal + 1, col: 0, rowspan: 1, colspan: 18}
          ];
        }
      }
    }
  }
</script>
<style scoped lang='scss'>
  .week {
    height: 100%;
    .atb-content-bg {
      margin-top: 15px;
      padding: 24px;
      flex: 1;
      .kpi-content {
        overflow: auto;
        flex-grow: 1;
      }
      ::v-deep .header-table {
        overflow: auto;
        flex-grow: 1;
        .vxe-table--header-wrapper {
          background-color: $--bg-color-complete !important;

        }
        .main-row{
          .vxe-cell{
            padding: 0;
          }
        }
      }
      .kpi-add {
        height: 48px;
        background-color: $--color-bg-table-header;
        color: $--color-primary;
        font-size: 14px;
        margin-top: -1px;
        padding: 0 15px;
        span {
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
  }
  .program-check {
    li {
      &:not(:last-child) {
        padding-bottom: 20px;
      }
      .el-checkbox__label {
        span {
          font-weight: bold;
        }
      }
      div {
        flex-grow: 1;
        margin-left: 15px;
        p {
          color: $--color-text-primary;
          font-size: 14px;
          &.desc {
            line-height: 1.5;
          }
          &.date {
            line-height: 1;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>